module.exports = __webpack_public_path__ + "img/pano-north-deck.4f9b2f09.jpg";